import ContactFormValidator from '../validation/ContactFormValidator';
import CustomerLocationHandler from '../modules/CustomerLocationHandler';
import isNumeric from '../modules/isNumeric';
import nodeListForEach from '../modules/nodeListForEach';
import { saveToStorage, getFromStorage } from '../used-vue/api/Storage';
import { initialSetup as setupBookAppointmentForm } from './modules/book-appointment-form';
import Swal from 'sweetalert2';
import { customEvent, generateLeadEvent } from '../modules/tracking/AnalyticsEvents';

require('../modules/polyfills/object-entries');
require('remodal');

export class ValuationWidget {
    constructor(options) {
        this.vrm = false;
        this.mileage = false;
        this.make = false;
        this.model = false;
        this.bodystyle = false;
        this.derivative = false;
        this.fuelType = false;
        this.engineSize = false;
        this.transmission = false;
        this.hasUkVehicleData = false;
        this.popoversCreated = false;
        this.loadingImage = '<img class="valuation-widget__loading-img" src="/images/valuations/valuing.svg" alt="Loading" />';
        this.usedVehicle = false;
        this.newVehicle = false;
        this.newModel = false;
        this.customerDetails = {};
        this.isManualValuation = false;
        this.isVue = false;
        this.fixedDealer = 0;
        this.dealerFilter = (dealer) => {
            if(dealer.is_national_centre == 1) return false;

            // If the page has a brand, filter the dealers by brand
            if (brand) {
                if (dealer.brand && brand == dealer.brand) {
                    return true;
                }
                return false;
            }

            return true;
        };

        // Flag to show if the reg_no and mileage inputs are present and visible on manual lookup form
        this.manualLookupHasRegAndMileage = false;

        // This is used on the thank you step
        // We set the value on the success callback for the manual valuation and failed valuation form submissions
        this.dealerName = false;

        // Fields used to create links on step 3
        this.manufacturer = false;
        this.directionsLink = false;
        this.offersLink = false;

        // Used on final step after booking appointment
        this.appointmentDate = null;
        this.appointmentTime = null;
        this.vehiclePrice = null;
        this.valuationCampaign = null;

        // Validators for the forms
        this.valuationValidator = false;
        this.manualLookupValidator = false;
        this.bookAppointmentValidator = false;

        // Callback functions
        this.onSuccessfulValuation = function(){};

        // Location handlers for the forms
        this.valuationLocationHandler = false;
        this.manualLookupLocationHandler = false;
        this.bookAppointmentLocationHandler = false;
        this.bookAppointmentDateChangeEvent = false;

        this.state = 'none';
        this.valuation = false;
        let target = '#valuation-widget';
        let startTarget = '#valuation-start';
        if (typeof options !== 'undefined') {
            if (typeof options.target !== 'undefined') {
                target = options.target;
            }

            if (typeof options.startTarget !== 'undefined') {
                startTarget = options.startTarget;
            }

            if (typeof options.loadingImage !== 'undefined') {
                this.loadingImage = options.loadingImage;
            }

            if (typeof options.onSuccessfulValuation !== 'undefined') {
                this.onSuccessfulValuation = options.onSuccessfulValuation;
            }

            if (typeof options.dealerFilter !== 'undefined') {
                this.dealerFilter = options.dealerFilter;
            }

            if (typeof options.isVue !== 'undefined') {
                this.isVue = options.isVue;
            }

            if (typeof options.fixedDealer !== 'undefined') {
                this.fixedDealer = options.fixedDealer;
            }
        }
        this.target = document.querySelector(target);
        this.targetJq = $(target);
        this.startTarget = document.querySelector(startTarget);
        if (this.target) {
            this.attachEventsToControls();
            this.attachValidation();
        }

        this.modalDiv = false;
        this.modalWindow = false;
    }

    /**
     * Get this instance's modal window, if one doesn't exist create it
     */
    getModalInstance()
    {
        if (this.modalWindow !== false) {
            return this.modalWindow;
        }

        this.modalDiv = document.createElement('div');
        this.modalDiv.classList.add('remodal');
        const date = new Date()
        this.modalDiv.dataset.remodalId = "valuation_widget_modal" + date.getTime();
        document.body.appendChild(this.modalDiv);
        this.modalWindow = $(this.modalDiv).remodal({ hashTracking: false });
        return this.modalWindow;
    }

    /**
     * Get this instance's modal div
     */
    getModalElement()
    {
        if (this.modalWindow !== false) {
            return this.modalDiv;
        }

        this.getModalInstance();
        return this.modalDiv;
    }

    resetUkVehicleData() {

        this.updateVehicleDetail('make', '');
        this.updateVehicleDetail('model', '');
        this.updateVehicleDetail('body_type', '');
        this.updateVehicleDetail('derivative', '');
        this.updateVehicleDetail('fuel_type', '');
        this.updateVehicleDetail('engine_size', '');
        this.updateVehicleDetail('transmission', '');
        this.updateVehicleDetail('first_registered', '');

        this.hasUkVehicleData = false;
    }

    noVehicleData() {
        customEvent('Valuation', 'Vehicle Information', 'Failure');
        this.resetUkVehicleData();
        this.confirmFailedRegistrationLookup();
        // this.setState('manual-lookup');
    }

    /**
     * Open a popup asking the customer to confirm their registration is correct before continuing to the manual lookup
     */
    confirmFailedRegistrationLookup() {
        this.getModalElement().innerHTML = `
            <p>We were unable to retrieve details of this vehicle. Please ensure you have entered the registration number correctly.</p>
            <label class="valuation-widget__failed-label">Registration:</label>
            <div class="valuation-widget__failed-value valuation-widget__failed-value--registration">${this.vrm}</div>
            <p>If correct, please click continue to fill out the form which will be sent to your nearest dealership. Otherwise please press back and adjust your registration.</p>
            <div class="valuation-widget__button-holder">
                <button type="button" class="btn btn-secondary btn-close">Back</button>
                <button type="button" class="btn btn-primary btn-continue-to-failed">Continue</button>
            </div>
        `;
            // <label class="valuation-widget__failed-label">Mileage:</label>
            // <div class="valuation-widget__failed-value">${number_format(this.mileage, 0)}</div>
        const continueToFailed = this.getModalElement().querySelector('.btn-continue-to-failed');
        if (continueToFailed) {
            continueToFailed.addEventListener('click', () => {
                this.getModalInstance().close();
                this.setState('manual-lookup');
            });
        }
        const closeButton = this.getModalElement().querySelector('.btn-close');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                this.getModalInstance().close();
                this.setState('none');
            });
        }

        this.getModalInstance().open();
    }

    resetValuation() {
        this.valuation = false;
        this.isManualValuation = false;
    }

    resetAll() {
        this.vrm = false;
        this.mileage = false;

        this.resetUkVehicleData();
        this.resetValuation();
        this.setState('none');
        if (!this.isVue) {
            // this.target.querySelectorAll('.clean-popover').forEach(element => {

            // })
            // const cleanPopover = this.targetJq.find(".clean-popover");
            // if (cleanPopover && cleanPopover.length > 0) {
            //     cleanPopover.popover('hide');
            // }
        }
    }

    attachValidation() {
        this.valuationValidator = new ContactFormValidator({
            element: this.targetJq.find('.step-2 form'),
            loadingTarget: '#valuation-widget',
            loadingHtml: `<div class="loading solid-bg"><div class="center">${this.loadingImage}<div class="loader-duration text-center"><p class="animated bounceIn">Please wait while we process your valuation request...</p></div></div></div>`,
            loadingIntervalCallback: duration => {
                const el = this.target.querySelector('.loader-duration');
                if (!el) {
                    return;
                }
                if (duration > 5 && duration < 10) {
                    if (!el.querySelector('.duration-10')) {
                        $(el).append('<p class="valuation-widget__duration duration-10 animated bounceIn">Apologies for the delay...</p>');
                    }
                    return true;
                }
                if (!el.querySelector('.duration-11')) {
                    $(el).append(`<p class="valuation-widget__duration duration-11 animated bounceIn">We'll have your valuation very soon!</p>`);
                }
                return true;
            }
        });
        // We don't need to reference this anywhere else, so just instantiating it with local scope
        if (this.fixedDealer == 0) {
            this.valuationLocationHandler = new CustomerLocationHandler();
            this.valuationLocationHandler.setAdditionalLocationFilterFunction(this.dealerFilter);
            this.valuationLocationHandler.setup(this.targetJq.find('.step-2 form').attr('id'));
        }

        this.manualLookupValidator = new ContactFormValidator({
            element: this.targetJq.find('.step-manual-lookup form'),
            loadingHtml: `<div class="loading">${this.loadingImage}</div>`,
        });
        if (this.fixedDealer == 0) {
            this.manualLookupLocationHandler = new CustomerLocationHandler();
            this.manualLookupLocationHandler.setAdditionalLocationFilterFunction(this.dealerFilter);
            this.manualLookupLocationHandler.setup(this.targetJq.find('.step-manual-lookup form').attr('id'));
        }
    }

    /**
     * Set the dealer filter to be applied to the contact forms
     *
     * @param {Function} newFilterFunction
     */
    setDealerFilter(newFilterFunction) {
        this.dealerFilter = newFilterFunction;
        if (this.valuationLocationHandler) {
            this.valuationLocationHandler.populateDealers();
        }
        if (this.manualLookupLocationHandler) {
            this.manualLookupLocationHandler.populateDealers();
        }
    }

    attachEventsToControls() {
        // General next/previous bindings
        this.target.querySelectorAll('.valuation-controls .continue').forEach(continueButton => {
            continueButton.addEventListener('click', () => {
                this.nextState();
            });
        });
        this.target.querySelectorAll('.valuation-controls .previous').forEach(previousButton => {
            previousButton.addEventListener('click', () => {
                this.prevState();
            });
        });

        // Step 1 specific binds
        this.target.querySelectorAll('a.incorrect-match').forEach(incorrectMatch => {
            incorrectMatch.addEventListener('click', () => {
                this.setState('manual-lookup');
            });
        });

        // Different binding for the form on step 2, as we need to submit a lead with it
        this.target.querySelectorAll('.valuation-controls .submit-valuation').forEach(getValuationButton => {
            getValuationButton.addEventListener('click', () => {
                this.getValuation();
            });
        });
        this.target.querySelectorAll('.valuation-controls .restart').forEach(restartButton => {
            restartButton.addEventListener('click', () => {
                this.resetAll();
            });
        });

        // Binding for form on manual lookup step
        this.target.querySelectorAll('.valuation-controls .submit-manual-lookup').forEach(submitManualLookupButton => {
            submitManualLookupButton.addEventListener('click', () => {
                this.getManualValuation();
            });
        });

        this.target.querySelectorAll('.step-failed .restart').forEach(restartButton => {
            restartButton.addEventListener('click', () => {
                this.resetAll();
            });
        });

        // Binding the button to jump to manual valuation before process started
        this.startTarget.querySelectorAll('.valuation-widget-manual-lookup').forEach(manualLookupButton => {
            manualLookupButton.addEventListener('click', () => {
                this.resetUkVehicleData();
                this.resetValuation();
                this.setState('manual-lookup');
            });
        });

        this.target.querySelectorAll('[data-valuation-btn="book appointment"]').forEach(bookAppointmentButton => {
            bookAppointmentButton.addEventListener('click', () => {
                this.setState('book-appointment');
                customEvent('Valuation', 'Book Appointment CTA', 'Clicked');
            });
        });
    }

    setRegistration(reg) {
        this.vrm = reg;
        this.updateVehicleDetail('reg_no', reg);
    }

    /**
     * Updates both the internal value of a vehicle detail from the API, and any front end areas
     * @param {*} key
     * @param {*} value
     */
    updateVehicleDetail(key = '', value = '')
    {
        if (this[key] == 'undefined') {
            return;
        }
        this[key] = value;
        const targetContainers = this.target.querySelectorAll('.vehicle-details__' + key)
        nodeListForEach(targetContainers, (index, targetContainer) => {
            const targetValue = targetContainer.querySelector('.vehicle-details__value')
            if (!targetValue) {
                return;
            }
            if (isNumeric(value) && value > 0) {
                targetContainer.style.display = '';
                targetValue.innerHTML = number_format(value, 0);
                return;
            }
            if (value !== '') {
                targetContainer.style.display = '';
                targetValue.innerHTML = value;
                return;
            }
            targetContainer.style.display = 'none';
            targetValue.innerHTML = '';
        });
    }

    setMileage(mileage) {
        this.mileage = mileage;
        this.updateVehicleDetail('mileage', mileage);
    }

    parseUkVehicleData(data) {
        if (typeof data.image !== 'undefined' && data.image !== '') {
            this.updateVehicleImage(data.image);
        }

        if (typeof data.info === 'undefined') {
            this.noVehicleData();
            return false;
        }

        this.hasUkVehicleData = false;
        Object.entries(data.info).forEach(value => {
            if (typeof value[1] == 'undefined') {
                return;
            }
            if (value[1] !== '')  {
                this.hasUkVehicleData = true;
            }
            this.updateVehicleDetail(value[0], value[1]);
        });

        if (!this.hasUkVehicleData) {
            this.noVehicleData();
            return false;
        }

        customEvent('Valuation', 'Vehicle Information', 'Success');
        this.setState('1');
    }

    updateVehicleImage(image) {
        let imgContainers = this.targetJq.find('.vehicle-img');
        imgContainers.find('img').remove();
        imgContainers.html(`<img src="${image}" class="img-responsive" />`);
    }

    getVehicleInformation(successCallback, errorCallback) {
        this.resetUkVehicleData();
        $.ajax({
            type: "POST",
            cache: true,
            dataType: 'json',
            url: '/valuation/vehicle-info',
            data: {
                reg_no: this.vrm,
                mileage: this.mileage
            },
            success: response => {
                // response should have data, so attempt to render it
                this.parseUkVehicleData(response);
                successCallback(response);
            },
            error: response => {
                customEvent('Valuation', 'Vehicle Information', 'Failure');
                this.setState('none');
                errorCallback(response);
            }
        });
    }

    parseValuation() {
        if (this.valuation == false ||
            typeof this.valuation.valuation == 'undefined' ||
            typeof this.valuation.valuation.valuation == 'undefined' ||
            parseInt(this.valuation.valuation.valuation) <= 0
        ) {
            customEvent('Valuation', 'Vehicle Valuation', 'Failed');
            generateLeadEvent('valuation_failed');
            this.setCtaUrls(this.valuation);
            this.setState('failed');
            return false;
        }

        customEvent('Valuation', 'Vehicle Valuation', 'Complete');
        generateLeadEvent('valuation_complete');

        this.vehiclePrice = `&pound;${number_format(this.valuation.valuation.valuation,0)}*`;
        this.valuationCampaign = null;

        // Put the valuations in their target boxes
        const valuationTargets = this.target.querySelectorAll('.valuation-result__clean');
        nodeListForEach(valuationTargets, (index, element) => {
            element.innerHTML = `&pound;${number_format(this.valuation.valuation.valuation,0)}*`;
        });

        if (this.valuation.valuation.vehicle_of_interest_type == 'new') {
            this.target.querySelectorAll('.valuation-terms').forEach(valuationTerms => {
                valuationTerms.setAttribute('style', 'display:none !important');
            });
        }

        // Handle adding any campaign bonus to the tool
        if (typeof this.valuation.valuation.valuationCampaign != 'undefined' && this.valuation.valuation.valuationCampaign > 0) {
            const totalValuation = number_format(this.valuation.valuation.valuation + this.valuation.valuation.valuationCampaign,0);
            this.valuationCampaign = {
                bonus: this.valuation.valuation.valuationCampaign,
                total: totalValuation
            };
            this.target.querySelectorAll('.valuation-result__campaign').forEach(campaignArea => {
                campaignArea.innerHTML = `<div class="valuation-result__campaign-text">Plus an additional £${this.valuation.valuation.valuationCampaign} when you sell your car to us</div><div class="valuation-result__campaign-total">£${totalValuation}*</div>`;
                campaignArea.style.display = 'block';
            });
        } else {
            this.target.querySelectorAll('.valuation-result__campaign').forEach(campaignArea => {
                campaignArea.style.display = 'none';
            });
        }

        // Put the valuation valid on in target boxes
        if (this.valuation.valuation.valuationValidOn) {
            const valuationTargets = this.target.querySelectorAll('.vehicle-valuation-valid-on');
            nodeListForEach(valuationTargets, (index, element) => {
                element.innerHTML = this.valuation.valuation.valuationValidOn;
            });
        }

        // Log the valuation in storage so it can be referenced on the front end by the used car finance calculator
        try {
            let currentValuationsArray = JSON.parse(getFromStorage('valuations', '[]'));
            const valuationArrayForStorage = {
                valuation: this.valuation.valuation.valuation,
                reg_no: this.valuation.valuation.reg_no,
                mileage: this.valuation.valuation.mileage,
                valid_on: this.valuation.valuation.valuationValidOn,
            };
            if (this.valuation.info.make) {
                valuationArrayForStorage.make = this.valuation.info.make;
            }
            if (this.valuation.info.model) {
                valuationArrayForStorage.model = this.valuation.info.model;
            }
            if (this.valuation.info.body_type) {
                valuationArrayForStorage.body_type = this.valuation.info.body_type;
            }
            if (this.valuation.info.derivative) {
                valuationArrayForStorage.derivative = this.valuation.info.derivative;
            }
            if (this.valuation.info.image) {
                valuationArrayForStorage.image = this.valuation.info.image;
            }
            let newValuationsArray = [valuationArrayForStorage];

            if (Array.isArray(currentValuationsArray)) {
                for (let index = 0, len = currentValuationsArray.length; index < len; index++) {
                    if (currentValuationsArray[index].reg_no !== valuationArrayForStorage.reg_no
                        || currentValuationsArray[index].mileage !== valuationArrayForStorage.mileage
                    ) {
                        newValuationsArray.push(currentValuationsArray[index]);
                    }
                    if (newValuationsArray.length == 3) {
                        break;
                    }
                }

                saveToStorage('valuations', JSON.stringify(newValuationsArray));
            } else {
                saveToStorage('valuations', JSON.stringify(newValuationsArray));
            }
            try {
                this.onSuccessfulValuation(this.valuation);
            } catch (error) {
                console.error('ValuationWidget@parseValuation: Error calling onSuccessfulValuation', error);
            }
        } catch (error) {
            console.error('ValuationWidget@parseValuation: Error storing valuation', error);
        }

        this.setCtaUrls(this.valuation);

        this.setState('3');
    }

    /**
     * Set the manufacturer, new car link and offers link from a response
     * @param {Object} response
     */
    setCtaUrls(response)
    {
        this.manufacturer = false;
        this.directionsLink = false;
        this.offersLink = false;

        if (typeof response.manufacturer !== 'undefined') {
            this.manufacturer = response.manufacturer;

            if (typeof response.directions_link !== 'undefined') {
                this.directionsLink = response.directions_link;
            }

            if (typeof response.offers_link !== 'undefined') {
                this.offersLink = response.offers_link;
            }
        }
    }

    showManufacturerCtas()
    {
        if (!this.manufacturer) {
            return;
        }

        if (this.directionsLink) {
            this.target.querySelectorAll('.valuation-result__directions-cta').forEach(element => {
                element.innerHTML = `<a href="${this.directionsLink}" target="_blank" rel="noopener" class="btn btn-primary btn--full-width">Get Directions</a>`;
            });
        }

        if (this.offersLink) {
            this.target.querySelectorAll('.valuation-result__offers-cta').forEach(element => {
                element.innerHTML = `<a href="${this.offersLink}" class="btn btn-secondary btn--full-width">Discover Offers</a>`;
            });
        }
    }

    // Manually passing in validator as each form will need a separate validator
    postDataFromForm(validator, formSelector) {
        return new Promise((resolve, reject) => {
            if (validator !== false && !validator.isValid()) {
                resolve(false);
                return false;
            }

            const formEl = this.target.querySelector(formSelector);
            if (formEl.length == 0) {
                resolve(false);
                return false;
            }

            let formData = new FormData(formEl);
            formData = this.appendExtraVariablesToFormData(formData);

            validator.preventInput();
            $.ajax({
                type: "POST",
                cache: false,
                processData: false,
                contentType: false,
                url: formEl.getAttribute('action'),
                data: formData,
                success: function(response) {
                    validator.successResponse();
                    resolve(response);
                },
                error: function(response) {
                    validator.errorResponse(response);
                    reject(response);
                }
            });
        })
    }

    getValuation() {
        this.postDataFromForm(this.valuationValidator, '.step-2 form')
        .then(response => {
            if (response === false) {
                return;
            }
            if (typeof response.request !== 'undefined') {
                this.customerDetails = response.request;
            }

            this.valuation = response;
            this.parseValuation();
        })
        .catch(errorData => {
            console.error('ValuationWidget@getValuation - Something went wrong: ', errorData);
        })
    }

    /**
     * Submits manual lookup form
     */
    getManualValuation() {
        // Need to update this.vrm and this.mileage if the manual lookup form has them filled in
        if (this.manualLookupHasRegAndMileage) {
            this.setRegistration(this.targetJq.find('.step-manual-lookup form input[name="reg_no"]').val());
            this.updateVehicleDetail('mileage', this.target.querySelector('.step-manual-lookup form input[name="mileage"]').value)
        }

        this.postDataFromForm(this.manualLookupValidator, '.step-manual-lookup form')
        .then(response => {
            if (response === false) {
                return;
            }
            customEvent('Valuation', 'Manual Lookup', 'Complete');
            generateLeadEvent('valuation_manual_lookup');

            if (typeof response.request !== 'undefined') {
                this.customerDetails = response.request;
            }

            this.setCtaUrls(response);

            // Set a base value for the dealerName in case it's not in the response
            this.dealerName = false;
            if (typeof response !== 'undefined' && typeof response.dealer !== 'undefined' && typeof response.dealer.name !== 'undefined') {
                this.dealerName = response.dealer.name;
            }
            this.isManualValuation = true;
            this.setState('thank-you');
        })
        .catch(errorData => {
            console.error(errorData);
        });
    }

    updateManualLookupMessage() {
        // The text at the top of this section should either show a failed lookup message, where the API returned no result for the reg, or an incorrect lookup message where the user is trying to manually match their result
        // We'll use the failed as a default, and if the vehicle data is set, then we'll use the incorrect.
        let classToShow = '.manual-lookup';
        if (this.vrm !== false) {
            classToShow = '.failed-lookup';
        }
        if (this.hasUkVehicleData !== false) {
            classToShow = '.incorrect-lookup';
        }
        this.targetJq.find('.step-manual-lookup .validation-error:not(' + classToShow + ')').hide();
        this.targetJq.find('.step-manual-lookup .validation-error' + classToShow).show();
    }

    determineIfManualLookupNeedsRegAndMileage() {
        if (this.vrm == false || this.mileage == false) {
            // Show the hidden inputs
            this.targetJq.find('.step-manual-lookup .skipped-step-1').show();
            // Flag the inputs as needed
            this.manualLookupHasRegAndMileage = true;
            return true;
        }

        // Set the inputs to the current vrm and mileage, so the form passes JS valiation
        this.targetJq.find('.step-manual-lookup [name="reg_no"]').val(this.vrm);
        this.targetJq.find('.step-manual-lookup [name="mileage"]').val(this.mileage);
        // Hide the inputs as they're not needed
        this.targetJq.find('.step-manual-lookup .skipped-step-1').hide();
        // Flag the inputs as not needed
        this.manualLookupHasRegAndMileage = false;
        return true;
    }

    /**
     * Adds things like reg_no, mileage and any vehicle of interest data to the formData
     */
    appendExtraVariablesToFormData(formData)
    {
        formData.append('reg_no', this.vrm,);
        formData.append('mileage', this.mileage,);

        if (this.usedVehicle) {
            formData.append('used_vehicle', this.usedVehicle,);
        }
        if (this.newModel) {
            formData.append('new_model', this.newModel,);
        }
        if (this.newVehicle) {
            formData.append('new_vehicle', this.newVehicle,);
        }
        if (this.isManualValuation) {
            if (typeof this.customerDetails.make != 'undefined') {
                formData.append('make', this.customerDetails.make);
            }
            if (typeof this.customerDetails.model != 'undefined') {
                formData.append('model', this.customerDetails.model);
            }
            if (typeof this.customerDetails.variant != 'undefined') {
                formData.append('variant', this.customerDetails.variant);
            }
            if (typeof this.customerDetails.extraInfo != 'undefined') {
                formData.append('extraInfo', this.customerDetails.extraInfo);
            }
            formData.append('isManualValuation', true);
        }

        return formData;
    }

    scrollToTarget(target) {
        // Scroll to target element
        // Offset by the height of the menu depending on screen size
        let offset = 125;
        if ($(window).width() < 992) {
            offset = 56;
        }
        let targetHeight = $(target).offset().top - offset;
        $('html, body').animate({ scrollTop: targetHeight }, 250);
    }

    async setState(state) {
        // If we're already in the state requested, then just return
        if (state == this.state) {
            // Unless this is the manual lookup state, in which case we need to deal with messages that change (this probably needs refactoring)
            if (this.state == 'manual-lookup') {
                this.updateManualLookupMessage();
                this.determineIfManualLookupNeedsRegAndMileage();
            }
            return false;
        }

        if (state == 'none') {
            this.target.classList.add('animated');
            this.target.classList.add('bounceOut');
            setTimeout(() => {
                this.target.classList.remove('bounceOut');
                this.target.classList.remove('animated');
                this.targetJq.hide();
                this.state = 'none';
            }, 300);

            // If we don't have a valid starting form target, then we just have to stop now
            if (!this.startTarget) {
                return true;
            }

            // Scroll back to the original form, if we have a startTarget
            // Focus first input in target form
            $(this.startTarget).find('input').first().focus();
            this.scrollToTarget(this.startTarget);
            return true;
        }

        // If the current state is none, then we need to load in the widget
        // Doing this here because step 1/2/3 all need the widget loaded, so might as well do this once at the start, rather than repeat the code in each state block below
        if (this.state == 'none') {
            this.target.classList.add('animated');
            this.target.classList.add('bounceIn');
            this.targetJq.show();
        }

        if (state == '1') {
            this.state = state;
            this.targetJq.find('.valuation-steps .step-1').addClass('step--active');
            this.targetJq.find('.valuation-steps .step:not(.step-1)').removeClass('step--active');

            setTimeout(function () {
                this.scrollToTarget(this.target);
            }.bind(this), 300);

            return true;
        }
        if (state == '2') {
            this.state = state;
            this.targetJq.find('.valuation-steps .step-2').addClass('step--active');
            this.targetJq.find('.valuation-steps .step:not(.step-2)').removeClass('step--active');
            this.scrollToTarget(this.target);
            return true;
        }
        if (state == '3') {
            this.state = state;
            this.targetJq.find('.valuation-steps .step-3').addClass('step--active');
            this.targetJq.find('.valuation-steps .step:not(.step-3)').removeClass('step--active');

            this.showManufacturerCtas();

            if (!this.isVue && this.popoversCreated == false) {
                this.target.querySelectorAll('.clean-popover').forEach(element => {
                    element.addEventListener('click', function() {
                        Swal.fire({
                            title: 'Good Condition',
                            html: `<ul class="good-condition__ul">
                                <li class="good-condition__li">Little or no refurbishment required for the dealer to sell</li>
                                <li class="good-condition__li">Mechanically sound without faults</li>
                                <li class="good-condition__li">Valid MOT certificate or requiring little or no attention to obtain one</li>
                                <li class="good-condition__li">Acceptable exterior colour and interior trim combination</li>
                                <li class="good-condition__li">Interior to be clean and well looked after, in original condition and without damage</li>
                                <li class="good-condition__li">All documentation in order and available</li>
                                <li class="good-condition__li">Spare keys and security codes supplied with the vehicle</li>
                                <li class="good-condition__li">Full service history</li>
                            </ul>`,
                            icon: 'info',
                            buttonsStyling: false,
                            customClass: {
                                confirmButton: 'btn btn-primary',
                            },
                        });
                    })
                });
                this.popoversCreated = true;
            }

            setTimeout(function () {
                this.scrollToTarget(this.target);
            }.bind(this), 350);

            return true;
        }

        if (state == 'manual-lookup') {
            this.state = state;

            this.updateManualLookupMessage();
            this.determineIfManualLookupNeedsRegAndMileage();

            this.scrollToTarget(this.target);

            this.targetJq.find('.valuation-steps .step-manual-lookup').addClass('step--active');
            this.targetJq.find('.valuation-steps .step:not(.step-manual-lookup)').removeClass('step--active');

            // We want to set step 2 as the heading for manual lookup
            this.targetJq.find('.valuation-steps.headings .step-2').addClass('step--active');
            this.targetJq.find('.valuation-steps.headings .step:not(.step-2)').removeClass('step--active');
            return true;
        }

        if (state == 'failed') {
            this.state = state;

            this.scrollToTarget(this.target);

            this.targetJq.find('.valuation-steps .step-failed').addClass('step--active');
            this.targetJq.find('.valuation-steps .step:not(.step-failed)').removeClass('step--active');

            // We want to set step 3 as the heading for failed lookups
            this.targetJq.find('.valuation-steps.headings .step-3').addClass('step--active');
            this.targetJq.find('.valuation-steps.headings .step:not(.step-3)').removeClass('step--active');
            return true;
        }

        if (state == 'thank-you') {
            this.state = state;

            this.scrollToTarget(this.target);
            this.showManufacturerCtas();

            // Set the HTML for the dealer name
            if (this.dealerName == false) {
                this.targetJq.find('.step-thank-you .dealer-name').html('your chosen dealer');
            } else {
                this.targetJq.find('.step-thank-you .dealer-name').html(this.dealerName);
            }

            this.targetJq.find('.valuation-steps .step-thank-you').addClass('step--active');
            this.targetJq.find('.valuation-steps .step:not(.step-thank-you)').removeClass('step--active');
            if (this.isManualValuation === true) {
                this.targetJq.find('.step-thank-you--show-book-appointment').addClass('step--active');
            }

            // We want to set step 3 as the heading for the thank you page
            this.targetJq.find('.valuation-steps.headings .step-3').addClass('step--active');
            this.targetJq.find('.valuation-steps.headings .step:not(.step-3)').removeClass('step--active');
            return true;
        }

        if (state == 'final-thank-you') {
            this.state = state;

            this.scrollToTarget(this.target);
            this.showManufacturerCtas();

            // Set the HTML for the dealer name
            if (this.dealerName == false) {
                this.targetJq.find('.step-final-thank-you .dealer-name').html('your chosen dealer');
            } else {
                this.targetJq.find('.step-final-thank-you .dealer-name').html(this.dealerName);
            }

            this.target.querySelectorAll('.step-final-thank-you .valuation-result__optional-content').forEach(element => element.innerHTML = '');
            if (this.appointmentTime !== null) {
                this.target.querySelectorAll('.step-final-thank-you .valuation-result__optional-content').forEach(element => {
                    const timeText = document.createElement('p');
                    timeText.innerHTML = 'Appointment time - ' + this.appointmentTime;
                    element.appendChild(timeText);
                })
            }
            if (this.appointmentDate !== null) {
                this.target.querySelectorAll('.step-final-thank-you .valuation-result__optional-content').forEach(element => {
                    const dateText = document.createElement('p');
                    dateText.innerHTML = 'Appointment date - ' + this.appointmentDate;
                    element.appendChild(dateText);
                })
            }
            if (this.vehiclePrice !== null) {
                this.target.querySelectorAll('.step-final-thank-you .valuation-result__optional-content').forEach(element => {
                    const valuationText = document.createElement('p');
                    valuationText.innerHTML = 'Your vehicle valuation price - ' + this.vehiclePrice;
                    element.appendChild(valuationText);
                    if (this.valuationCampaign == null) {
                        return;
                    }
                    const bonus = document.createElement('p');

                    bonus.innerHTML = `Plus an additional £${this.valuationCampaign.bonus} when you sell your car to us, for a total of £${this.valuationCampaign.total}*`;
                    element.appendChild(bonus);
                })
            }

            this.targetJq.find('.valuation-steps .step-final-thank-you').addClass('step--active');
            this.targetJq.find('.valuation-steps .step:not(.step-final-thank-you)').removeClass('step--active');

            // We want to set step 3 as the heading for the final thank you page
            this.targetJq.find('.valuation-steps.headings .step-3').addClass('step--active');
            this.targetJq.find('.valuation-steps.headings .step:not(.step-3)').removeClass('step--active');
            return true;
        }

        if (state == 'book-appointment') {
            this.state = state;
            setupBookAppointmentForm(this.target.querySelector('#submitAppointment'), this);

            this.targetJq.find('.valuation-steps .step-book-appointment').addClass('step--active');
            this.targetJq.find('.valuation-steps .step:not(.step-book-appointment)').removeClass('step--active');
            this.targetJq.find('.valuation-steps.headings .step').hide();
            this.scrollToTarget(this.target);
            return true;
        }
    }

    prevState() {
        if (this.state == '3') {
            this.setState('2');
            return true;
        }
        if (this.state == '2') {
            this.setState('1');
            return true;
        }
        if (this.state == 'manual-lookup') {
            if (this.hasUkVehicleData) {
                this.setState('1');
                return true;
            }
            this.resetAll();
            return true;
        }
        return false;
    }

    nextState() {
        if (this.state == '1') {
            this.setState('2');
            return true;
        }
        return false;
    }

    associateUsedVehicle(id) {
        this.usedVehicle = id;
    }

    associateNewModel(id) {
        this.newModel = id;
    }

    associateNewVehicle(id) {
        this.newVehicle = id;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/valuations/ValuationWidget.js